<!-- 表2填写 -->

<template>
  <div class="tabCage ssTab4E">
    <div class="tabTtl">
      <span>人员基本信息</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">岗位类别：</td>
            <td class="radioText">
              <el-form-item prop="type" :inline-message="true">
                <el-radio-group v-model="params.type" @change="tabSeek">
                  <el-radio :label="1">主要负责人</el-radio>
                  <el-radio :label="2">其他负责人</el-radio>
                  <el-radio :label="3">编辑人员</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">姓名：</td>
            <td class="edInp">
              <el-form-item prop="fullName" :inline-message="true">
                <el-input v-model="params.fullName" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">性别：</td>
            <td class="radioText">
              <el-form-item prop="gender" :inline-message="true">
                <el-radio-group v-model="params.gender" @change="tabSeek">
                  <el-radio v-for="item in dicDats['C017']" :label="item.code" :key="item.code">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">身份证号（军官证号）：</td>
            <td class="edInp areaTime">
              <el-form-item prop="idNumber" :inline-message="true">
                <el-input v-model="params.idNumber" size="small"></el-input>
              </el-form-item>
              <div class="tips">军官证号填写示例：军字第xxxxxxx号。编号位数据实情填写。</div>
            </td>
          </tr>
          <tr v-if="params.type != 3">
            <td class="edName">职务：</td>
            <td class="edInp areaTime">
              <el-form-item prop="job" :inline-message="true">
                <el-select v-model="params.job" size="small" placeholder="请选择职务">
                  <el-option v-for="item in dicDats['C022']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="dicMap['C022'][params.job] == '其他'" prop="professionalOther" :inline-message="true">
                <el-input v-model="params.professionalOther" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">政治面貌：</td>
            <td class="edInp">
              <el-form-item prop="politicalStatus" :inline-message="true">
                <el-select v-model="params.politicalStatus" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C006']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">文化程度：</td>
            <td class="edInp">
              <el-form-item prop="culture" :inline-message="true">
                <el-select v-model="params.culture" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C005']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="cellphone" :inline-message="true">
                <el-input v-model="params.cellphone" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">专业：</td>
            <td class="edInp">
              <el-form-item prop="major" :inline-message="true">
                <el-input v-model="params.major" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">职称系列：</td>
            <td class="edInp">
              <el-form-item prop="professionalTitleSeries" :inline-message="true">
                <el-select v-model="params.professionalTitleSeries" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C007']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">职称级别：</td>
            <td class="edInp">
              <el-form-item prop="titleLevel" :inline-message="true">
                <el-select v-model="params.titleLevel" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C008']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">持有出版专业职业资格证书情况：</td>
            <td class="edInp">
              <el-form-item prop="certificateSituation" :inline-message="true">
                <el-select v-model="params.certificateSituation" @change="btnCtrls(1)" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C009']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>

          <tr v-if="params.type != 3">
            <td class="edName">是否持有岗位培训合格证书：</td>
            <td class="edInp">
              <el-form-item prop="isTrainCertificate" :inline-message="true">
                <el-select v-model="params.isTrainCertificate" @change="btnCtrls(1)" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>

        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="modifyFlag" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>

  </div>
</template>

<script>
import {
  bsParams,
  paramsRule
} from '@/components/LongParams/paramsSEt4';
import {
  ssSave4,
  ssRead4,
  getLxdzModifyFlagByPublication,// zym.判断数据是否可以修改
} from '@/api/pressRole/pressSuccessive';
export default {

  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C022: {}
      },
      
      modifyFlag: false,
    }
  },
  methods: {
    tabSeek: function () {

    },
    dictInit: function () {
      let nameArr = ['C022', 'C006', 'C005', 'C007', 'C008', 'C009', 'C018', 'C017'];
      let newPromise = this.$store.dispatch('dictUpdate', {
        codeArr: nameArr,
        type: 'arr'
      });
      newPromise.then(result => {
        this.dicDats = result;
        this.dicMap['C022'] = this.$store.getters.dictionary['C022'];
      })

    },

    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {

          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          this.params.publishType = this.$route.query.pressType;

          ssSave4({
            // plxdzworker: this.params
            publishMaterialId: this.$route.query.mtId,// zym.基本信息
            data: this.params
          }).then(response => {
            console.log('response=', JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.tipMessage;
            if (tipCode == 'fail') {
              this.$message({
                message: tipMessage,
                type: 'error'
              })
            }
            else {
              that.submiting = false;
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              if (tipCode == 'fail') {
                that.$message({
                  message: tipMessage,
                  type: 'error'
                })
                return;
              }
              that.$message({
                message: '保存成功！',
                type: 'success'
              });

              that.goBack();
            }
          }).catch(error => {
            this.submiting = false;
          })
        } else {
          return false;
        }
      })
    },

    // zym.控制是否显示
    btnCtrls: function (type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    // zym.读取单位人员信息
    menReEdit: function () {
      ssRead4({
        id: this.$route.query.id,
        publishMaterialId: this.$route.query.mtId // zym.新增，用于判断是否可以修改数据
        ,judgeModify:true
      }).then(response => {
        // console.log('response=', JSON.stringify(response));
        this.params = response.plxdzworker;

        this.modifyFlag = response.modifyFlag;
        // console.log('modifyFlag=',this.modifyFlag)
      })
    },


    goBack: function () {
      this.$router.go(-1);
    }
    // zym.判断是否可以修改
    ,getLxdzModifyFlagByPublication:function(){
      console.log('getLxdzModifyFlagByPublication...')
      let vm = this;
      getLxdzModifyFlagByPublication({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(response => {
        vm.modifyFlag = response.payload;        
      })
    }
  },
  created: function () {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.dictInit();
    this.params.type = 3;
    // zym.pgress 新增-1，还是修改-2
    if (this.$route.query.pgress == 2) {
      this.menReEdit();
    }
    else{
      this.modifyFlag = true;
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = '';
    }
  }
}
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.ssTab4E .radioText {
  padding-left: 15px;
  padding-bottom: 13px;
}

.ssTab4E .radioText .el-radio__label {
  margin-left: -5px;
}

.ssTab4E .edName {
  width: 240px !important;
}

.ssTab4E .areaTime .el-form-item {
  display: inline-block;
  vertical-align: middle;
}

.ssTab4E .areaTime .tips {
  display: inline-block;
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// ssTab4.vue?352aebcc